import { useState } from "react";
import { ArrowUp, Loader2 } from "lucide-react";

/** Message box — Enter sends, Shift+Enter makes a new line. */
export default function AssistantComposer({ onSend, busy }) {
  const [text, setText] = useState("");
  const submit = () => {
    if (!text.trim() || busy) return;
    onSend(text);
    setText("");
  };
  return (
    <div className="flex items-end gap-2 rounded-2xl border border-white/10 bg-black/40 p-2 focus-within:border-amber-300/50">
      <textarea
        data-testid="assistant-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); } }}
        rows={2}
        maxLength={4000}
        placeholder="Ask ChatGPT about your song…"
        className="max-h-40 min-h-[44px] flex-1 resize-none bg-transparent px-2 py-1.5 text-[14px] text-white placeholder:text-white/35 focus:outline-none"
      />
      <button type="button" data-testid="assistant-send" onClick={submit} disabled={busy || !text.trim()} aria-label="Send"
        className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-amber-300 text-[#05070f] transition-transform duration-200 hover:scale-105 disabled:opacity-30 disabled:hover:scale-100">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowUp className="h-4 w-4" />}
      </button>
    </div>
  );
}
